import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from './global-store-base';

export const useWebhooks = defineStore('webhooks', () => {
  const api = useApi();

  const globalStoreBase = useGlobalStore({
    load: api.webhook_GetWebhooks,
    dto: 'WebhookDto',
    create: api.webhook_Create,
    update: api.webhook_Update,
    delete: api.webhook_Delete,
    signalR: 'WebhookUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
